import * as React from 'react'

import Modal                      from '@material-ui/core/Modal/Modal'
import createStyles               from '@material-ui/core/styles/createStyles'
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles'

import withToggle, { InjectedToggleProps } from '../hocs/withToggle'

interface AvatarProps {
  photo: string
}

const styles = createStyles(
  {
    inlineAvatar:  {
      height:       36,
      width:        36,
      borderRadius: '50%',
      cursor:       'pointer',
      objectFit:    'cover',
    },
    popOverAvatar: {
      objectFit:    'cover',
      outline:      'none',
      borderRadius: '50%',
      width:        200,
      height:       200,
    }
  }
)

type Props =
  InjectedToggleProps
  & AvatarProps
  & WithStyles<typeof styles>

const Avatar = ({
  activate,
  deactivate,
  isActive,

  photo,
  classes,
}: Props) => (
  <>
    <img
      src={photo}
      onClick={activate}
      className={classes.inlineAvatar}
    />
    <Modal
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}
      onClose={deactivate}
      open={isActive}
    >
      <img
        src={photo}
        className={classes.popOverAvatar}
      />
    </Modal>
  </>
)

export default withStyles(styles)<AvatarProps>(withToggle(Avatar))



// WEBPACK FOOTER //
// ./src/components/organisms/Avatar.tsx